/**
 * BuildSearchParameters
 *
 * Module that takes the query string parameter and builds it into an object
 *
 * @return {type}
 */

OT.createNS('OT.Search.Helpers.QueryString');

OT.Search.Helpers.QueryString = function(queryString) {
        if (queryString === undefined) {
            queryString = window.location.search;
        }
    
        if (queryString === "") {
            return {};
        }
    
        queryString = queryString.substr(1).split('&');
        var parsedQueryString = {};
        for (var i = 0; i < queryString.length; ++i)
        {
            var keyValue=queryString[i].split('=');
            if (keyValue.length !== 2) {
                continue;
            }
            
            parsedQueryString[keyValue[0].toLowerCase()] = decodeURIComponent(keyValue[1].replace(/\+/g, " "));
        }
    
        return parsedQueryString;
};